import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Sun, Home, Moon } from 'lucide-react';
export function SolutionReveal() {
  return <section className="py-24 px-6 bg-charcoal text-linen" data-id="element-154">
      <div className="max-w-3xl mx-auto" data-id="element-155">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} data-id="element-156">
          <div className="text-center mb-16" data-id="element-157">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-muted-blue/20 text-muted-blue-light text-sm font-medium tracking-wide uppercase mb-6 border border-muted-blue/30" data-id="element-158">
              <Lock className="w-4 h-4" data-id="element-159" /> The Mechanism
            </span>
            <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6 text-white" data-id="element-160">
              The Solution: Friction‑Locking Routines
            </h2>
            <p className="text-xl text-linen/80 max-w-2xl mx-auto leading-relaxed" data-id="element-161">
              This is the mechanism that makes calm possible on low bandwidth.
              Instead of a complicated routine, you install:
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-162">
            {[{
            label: '1 Order',
            desc: 'No shuffling steps'
          }, {
            label: '1 Script',
            desc: 'No negotiating words'
          }, {
            label: '1 Min. Version',
            desc: 'For the bad days'
          }].map((item, i) => <div key={i} className="bg-white/5 border border-white/10 p-6 rounded-lg text-center backdrop-blur-sm" data-id="element-163">
                <p className="text-2xl font-serif font-bold text-white mb-2" data-id="element-164">
                  {item.label}
                </p>
                <p className="text-linen/60 text-sm uppercase tracking-wider" data-id="element-165">
                  {item.desc}
                </p>
              </div>)}
          </div>

          <div className="space-y-4 max-w-xl mx-auto" data-id="element-166">
            <p className="text-center text-lg mb-8 text-linen/90" data-id="element-167">
              Across three anchors:
            </p>

            <div className="flex items-center gap-6 p-4 bg-white/10 rounded-xl border border-white/5" data-id="element-168">
              <div className="w-12 h-12 rounded-full bg-terracotta/20 flex items-center justify-center shrink-0 text-terracotta" data-id="element-169">
                <Sun className="w-6 h-6" data-id="element-170" />
              </div>
              <span className="text-xl font-serif" data-id="element-171">1) Morning</span>
            </div>

            <div className="flex items-center gap-6 p-4 bg-white/10 rounded-xl border border-white/5" data-id="element-172">
              <div className="w-12 h-12 rounded-full bg-sage/20 flex items-center justify-center shrink-0 text-sage" data-id="element-173">
                <Home className="w-6 h-6" data-id="element-174" />
              </div>
              <span className="text-xl font-serif" data-id="element-175">
                2) After-school re-entry
              </span>
            </div>

            <div className="flex items-center gap-6 p-4 bg-white/10 rounded-xl border border-white/5" data-id="element-176">
              <div className="w-12 h-12 rounded-full bg-muted-blue/20 flex items-center justify-center shrink-0 text-muted-blue-light" data-id="element-177">
                <Moon className="w-6 h-6" data-id="element-178" />
              </div>
              <span className="text-xl font-serif" data-id="element-179">3) Bedtime shutdown</span>
            </div>
          </div>

          <div className="mt-16 text-center" data-id="element-180">
            <p className="text-2xl font-serif italic text-linen/90" data-id="element-181">
              When those anchors are predictable, your whole house gets quieter.
              <br data-id="element-182" />
              <span className="not-italic font-sans font-bold text-white mt-4 block text-lg" data-id="element-183">
                Not perfect. Quieter.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}